



































































import CampaignHelper from "@/helpers/campaign";
import Campaign from "@/models/campaign";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CampaignReportInfo extends Vue {
  @Prop() campaign!: Required<Campaign>;
  @Prop() selfContained!: boolean;
  @Prop() startDate!: string;
  @Prop() endDate!: string;

  campaignStatusColor(status: string): string {
    return CampaignHelper.getColorClass(status);
  }

  get campaignStartDate(): string {
    return this.campaign
      ? moment(this.campaign.start).format("DD MMM YYYY")
      : "";
  }

  get campaignEndDate(): string {
    return this.campaign ? moment(this.campaign.end).format("DD MMM YYYY") : "";
  }
}
